module.exports = __webpack_public_path__ + "media/_archive/A-2ea7b89b.png";